  <lib-page-editor [updateFunction]="updateFunction" [editorData]="pageEditorData" [isLoadingData]="isLoadingData()"></lib-page-editor>
